@if (!!locationList && locationList.length === 0 && loading === true) {
  <div class="loading">Loading charges...</div>
}

@for (location of locationList; track location; let i = $index) {
  <div>
    <div class="location-header">
      <app-location-icon [kind]="location.getKind()"></app-location-icon>
      @if (editingLocationId() === location.getId()) {
        <input
          #labelInput
          type="text"
          pInputText
          class="location-name-input"
          placeholder="Local Costs {{ location.getName() }}"
          [value]="getLocalCostLabel(location)"
          (keydown.enter)="commitLabel(location, $event.target.value)"
          (keydown.escape)="cancelEdit()"
          (blur)="commitLabel(location, $event.target.value)"
        />
        <button
          type="button"
          pButton
          severity="primary"
          variant="text"
          class="location-name-save"
          aria-label="Save local costs label"
          (mousedown)="$event.preventDefault()"
          (click)="commitLabel(location, labelInput.value)"
        >
          <i class="pi pi-check"></i>
        </button>
      } @else {
        <span class="location-name">{{ getLocalCostLabelText(location) }}</span>
        @if (canChangeLabel() && supportsLabel()) {
          <button
            type="button"
            pButton
            severity="primary"
            variant="text"
            class="location-name-edit"
            aria-label="Edit local costs label"
            (click)="startEdit(location)"
          >
            <i class="pi pi-pencil"></i>
          </button>
        }
      }
      @if (showsAgentRequests()) {
        <app-agent-request-links
          label="Request charges from agent"
          [count]="agentRequestCounts.forLocation(location.getId())"
          [queryParams]="locationAgentRequestParams(location)"
          (requested)="requestChargesFromAgent(location)"
        />
      }
    </div>
    <app-table
      class="quote-{{ quote().quoteType }}"
      [columns]="columns"
      [selectable]="true"
      [headerSelectable]="false"
      [editable]="true"
      [addable]="true"
      [reorderable]="true"
      [loading]="loading"
      [value]="location.getSurcharges()"
      [rowDisabled]="isRowDisabled"
      [newValue]="newSurcharge[location.getId()]"
      (selectRow)="onRowSelect(location, $event)"
      (unSelectRow)="onRowUnselect($event)"
      [(selection)]="selection[location.getId()]"
      (saveRow)="onSaveSurcharge(location, $event)"
      (reorderRows)="onReorder(location, $event)"
    >
    </app-table>
  </div>
}

@if (agentRequestTarget) {
  <app-agent-request-dialog
    [quote]="quote()"
    [target]="agentRequestTarget"
    (sent)="onAgentRequestsSent()"
    (closed)="agentRequestTarget = null"
  />
}
